import {cuppa, log, val} from "../../cuppa/cuppa";
import {Globals} from "./Globals";
import {UserCtrl} from "./UserCtrl";
import {Constants} from "./Constants";
import {GraphQL} from "./GraphQL";

export class Utils{

	static parseJWT(token) {
		let base64Url = token.split('.')[1];
		let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
		return JSON.parse(jsonPayload);
	}

	static getColorsByAssessedStatus(number){
		let background;
		let color;
		if(number >=9 ){
			background = '#cc0000';
			color = '#FFF';
		}else if(number >=7){
			background = '#ff8800';
			color = '#FFF';
		}else if(number >=4){
			background = '#FDF845';
			color = '#6C757D';
		}else if(number >= 1){
			background = '#00c851';
			color = '#FFF';
		}else{
			background = 'transparent';
			color = '#6C757D';
		}
		return {background, color};
	}

	static getLabelByAssessedStatus(number){
		if(number === undefined) return '';
		if(!number) return '';
		if(number <= 3){
			return 'Healthy';
		}else if(number <= 6){
			return 'Reacting';
		}else if(number <= 8){
			return 'Injured';
		}else{
			return 'Ill';
		}
	}

	// data: {key:value,...}
	static updateURLValue(data, path = ''){
		if(!data) data = {};
		let url = cuppa.updateURLValue(data, path, {autoUpdate:false});
		Globals.router.history.push(url);
	}

	static redirect(path, {reload = false, appendRedirect = false, forcePath = false, resendRedirect = false} = {}){
		let redirect = cuppa.base64Decode(cuppa.urlValue('redirect'));
		if(redirect && resendRedirect){
			path += `&redirect=${cuppa.urlValue('redirect')}`;
		}else if(redirect && !forcePath){
			path = redirect;
		}else if(appendRedirect){
			let redirectData = `${path.indexOf('?') === -1 ? '?' : '&'}redirect=${cuppa.base64Encode(`/${cuppa.getPath()}`)}`;
			path += redirectData;
		}

		if(reload){
			window.location.href = path;
		}else{
			Globals.router.history.push({
				pathname:path,
			});
		}

	}

	static getDatesFromRange({from, to, type = 'months-between', returnString = false, allMonths = true, removeTime = true}){
		let minMonth = new Date();
		let maxMonth = new Date();
		if(type == 'months-between'){
			if(to == -1) to = 9999;
			minMonth.setMonth(minMonth.getMonth()-parseInt(from)-parseInt(to));
			maxMonth.setMonth(maxMonth.getMonth()-parseInt(from));
		}
		if(allMonths){
			minMonth.setDate(1);
			minMonth.setHours(0, 0, 0, 0);
			maxMonth.setMonth(maxMonth.getMonth()+1);
			maxMonth.setDate(0);
			maxMonth.setDate(maxMonth.getDate()-1);
			maxMonth.setHours(23, 59, 59, 999);
		}
		if(returnString){
			minMonth = minMonth.toISOString();
			maxMonth = maxMonth.toISOString();
			if(removeTime){
				minMonth = minMonth.substring(0, 10);
				maxMonth = maxMonth.substring(0, 10);
			}
		}
		return {min:minMonth, max:maxMonth}
	}

	static getLastQuarters(data, totalQuarters = 4) {
		data = cuppa.arrayObjectSort(data, 'date', 'desc');
		if(!data?.length) return;
		const maxDate = new Date(`${data[0].date}-01 00:00:00`);
		let dataMap = cuppa.arrayToMap(data, 'date');
		let year = maxDate.getFullYear();
		let month = maxDate.getMonth()+1;
		let quarter = Math.ceil(month/3);
		let result = [];
		for(let i = 0; i < totalQuarters; i++){
			let label = `${year}-Q${quarter}`;
			let month1 = cuppa.left0(((quarter-1)*3)+1);
			let month2 = cuppa.left0(((quarter-1)*3)+2);
			let month3 = cuppa.left0(((quarter-1)*3)+3);
			let monthsKeys = [`${year}-${month1}`, `${year}-${month2}`, `${year}-${month3}`];
			let total = 0;
			monthsKeys.map(month=>{
				total += val(dataMap, `${month}.total`, 0);
			});
			result.push({date:(total) ? label : '-', total});
			if(quarter == 1){
				quarter = 4;
				year--;
			}else{
				quarter--;
			}
		}
		return result;
	}

	static getLastWeeks(data, totalWeeks = 12) {
		data = cuppa.arrayObjectSort(data, 'date', 'desc');
		let dataMap = cuppa.arrayToMap(data, 'date');
		let maxDate = new Date();
			maxDate.setDate(maxDate.getDate()+6-maxDate.getDay());
		let daysInWeek = totalWeeks*7;
		let weekCount = 1;
		let result = [{date:'', total:0, weekCount}];
		for(let i = 1; i < daysInWeek; i++){
			if(weekCount > totalWeeks) break;
			let date = [`Week ${weekCount}`];
			let minWeekDate = new Date(maxDate);
				minWeekDate.setDate(minWeekDate.getDate()-minWeekDate.getDay());
			let maxWeekDate = new Date(maxDate);
				maxWeekDate.setDate(maxWeekDate.getDate()+6-maxWeekDate.getDay());
				date.push(`${minWeekDate.toISOString().substring(0, 10)}`);
			let key = cuppa.dateFormat(maxDate, 'yyyy-mm-dd');
			let data = dataMap[key];
			let lastItem = result[result.length-1];
				lastItem.total += parseInt(val(data, `total`, 0));
				lastItem.date = date;
			if(maxDate.getDay() === 0){
				weekCount++;
				result.push({date:`Week ${weekCount}`, total:0, weekCount});
			}
			maxDate.setDate(maxDate.getDate()-1);
		}
		return result
	}

	static getDates({returnString = true, noRange = false, urlFriendly = false, monthsBack = 12, from} = {}){
		let currentDate = new Date();
		let range = Utils.getDatesFromRange({from:0, to:(noRange) ? 12*50 : monthsBack, returnString});
		if(!from){
			from = cuppa.urlValue('from') ? cuppa.urlValue('from') : noRange ? `${currentDate.getFullYear()-2}-01-01` : range.min;
		}else{
			from = String(from).substring(0, 10);
		}
		let to = cuppa.urlValue('to') ? cuppa.urlValue('to') : range.max;
		let result = {from, to};
		if(urlFriendly) return cuppa.objectToURL(result);
		return result;
	}

	static sortBy(by, allowReset = false){
		if(cuppa.urlValue('orderBy') === by && cuppa.urlValue('orderType') === 'ASC'){
			Utils.updateURLValue({orderBy:by, orderType:'DESC'})
		}else if(cuppa.urlValue('orderBy') === by && cuppa.urlValue('orderType') === 'DESC' && allowReset){
			Utils.updateURLValue({orderBy:'', orderType:''})
		}else{
			Utils.updateURLValue({orderBy:by, orderType:'ASC'});
		}
	}

	static resizeBase64Image({base64, maxWidth, maxHeight, type = 'image/jpeg', quality = 0.8} = {}) {
		return new Promise((resolve, reject) => {
			let img = new Image();
			img.onload = function () {
				let width = img.width;
				let height = img.height;
				if (width > maxWidth || height > maxHeight) {
					let ratio = Math.min(maxWidth / width, maxHeight / height);
					width *= ratio;
					height *= ratio;
				}
				let canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				let ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, width, height);
				let resizedBase64 = canvas.toDataURL(type, quality);
				resolve(resizedBase64);
			};
			img.onerror = function () {
				reject(new Error('Error loading image'));
			};
			img.src = base64;
		});
	}

	static showMenuAccordingEmail(){
		let user = UserCtrl.getUser();
		if((user?.email || '').indexOf('refineddata.com') != -1) return true;
		if((user?.email || '').indexOf('mentalhealthtechnologies.ca') != -1) return true;
		return false;
	}

	static getConversationStatus(){
		if(cuppa.urlValue('status') === 'CLOSED'){
			return [Constants.conversationStatus.TERMINATED_BY_SUPPORTED, Constants.conversationStatus.TERMINATED_BY_USER]
		}else if(cuppa.urlValue('status')){
			return [cuppa.urlValue('status')];
		}
	}

	// return duration in minutes
	static calculateDuration(date1, date2){
		if(!date1 || !date2) return 0;
		if(typeof date1 === 'string') date1 = new Date(date1);
		if(typeof date2 === 'string') date2 = new Date(date2);
		const diffInMs = Math.abs(new Date(date2) - new Date(date1));
		let diffInMinutes = Math.ceil(diffInMs / (1000 * 60));
		if(!diffInMinutes) diffInMinutes = 1;
		return diffInMinutes;
	}

	static formatDateTime(dateString){
		if(!dateString) return '';
		const date = new Date(dateString);
		const now = new Date();
		const options = { month: 'long', day: 'numeric' };
		// Check if the date is today
		if (date.toDateString() === now.toDateString()) {
			return 'Today';
		}
		// Check if the date is within the current year
		if (date.getFullYear() === now.getFullYear()) {
			return date.toLocaleDateString('en-US', options);
		}
		// For dates in previous years
		options.year = 'numeric';
		return date.toLocaleDateString('en-US', options);
	}

	static prepareHTMLText(htmlText){
		if(!htmlText) return;
		htmlText = String(htmlText || '').replaceAll('<a ', `<a target="_blank" `);
		return cuppa.htmlEntitiesDecode(htmlText);
	}

	static async loadTimezones(){
		let timezonesRes = await GraphQL.query({query:`#graphql
      {
        timezones {
          id, country, name
        }
      }`, addRootBrackets:false, printResult:false
		});
		let timezones = timezonesRes?.data?.timezones || [];
		for(let timezone of timezones){
			timezone.offset = Utils.getTimezoneGMTOffset(timezone?.name);
			timezone.name = `${timezone.name} (GMT ${timezone.offset})`;
		}
		return timezones;
	}

	static getTimezoneGMTOffset(myTimezoneName) {
		const options = {timeZone: myTimezoneName, timeZoneName: "longOffset"};
		const dateText = Intl.DateTimeFormat([], options).format(new Date);
		let timezoneString = dateText.split(" ")[1].slice(3) || '+00:00';
		return timezoneString
	}
	
	static previewBase64({base64}){
		if (!base64) return;
		const html = `
			<!DOCTYPE html>
			<html>
			<body style="margin:0;display:flex;align-items:center;justify-content:center;height:100vh;">
				<img src="${base64}" />
			</body>
			</html>
		`;
		const blob = new Blob([html], { type: 'text/html' });
		const url = URL.createObjectURL(blob);
		window.open(url, '_blank');
		setTimeout(() => URL.revokeObjectURL(url), 10000);
	}
	
	static adjustURL(url){
		if(!url) return '';
		if(String(url).includes('http://') || String(url).includes('https://')) return url;
		return `https://${url}`;
	}
	
	static openURL({url, target = '_blank'}){
		if(!url) return;
		window.open(Utils.adjustURL(url), target);
	}
}
